import { Injector } from '@angular/core';
import { TableDataSource } from '@shared/table/table.datasource';
import { HistoryGetParams } from '@shared/types/history_get_params';
import { finalize } from 'rxjs/operators';

export class VersionDatasource extends TableDataSource {
  private documentId: string;
  private documentVersion: string;
  constructor(injector: Injector, documentId: string, documentVersion: string) {
    super(injector);
    this.documentVersion = documentVersion;
    this.documentId = documentId;
  }

  loadData(params: HistoryGetParams): void {
    this.onLoadDataStart();
    this.api.documents.byId.history
      .get(this.documentId, params)
      .pipe(finalize(() => this.onLoadDataEnd()))
      .subscribe((paginatedGetHistories) => {
        // eslint-disable-next-line radix
        const versionMajor = parseInt(this.documentVersion.split('.')[0]);
        paginatedGetHistories.data.map((history) => {
          if (history.last_actor) {
            history.user = `${history.last_actor.first_name} ${history.last_actor.last_name}`;
          }
          if (history.version) {
            history.view_version = `${history.version.major}.${history.version.minor}`;
            if (history.view_version === this.documentVersion) {
              history.canDownload = true;
            } else if (history.version.major === versionMajor || history.version.major === versionMajor - 1) {
              history.canDownload = true;
              history.canRestore = true;
            }
          }
        });
        this.paginatedGet.next(paginatedGetHistories);
      });
  }
}
